import { OnboardingVariantIdType } from "@/domain/onboarding";

import { allStepsWithImagesVariant } from "./allStepsWithImages";
import { defaultVariant } from "./default";
import { improvedVerbiageVariant } from "./improvedVerbiage";
import { introStepWithImageVariant } from "./introStepWithImage";
import { noConcernsStepVariant } from "./noConcernsStep";
import { OnboardingVariantType } from "./types";

export const ONBOARDING_VARIANTS: Record<
  OnboardingVariantIdType,
  OnboardingVariantType
> = {
  default: defaultVariant,
  noConcernsStep: noConcernsStepVariant,
  introStepWithImage: introStepWithImageVariant,
  improvedVerbiage: improvedVerbiageVariant,
  allStepsWithImages: allStepsWithImagesVariant,
};
